import { useGetWidthCategory } from '@utilities/common_hooks';
import React, { CSSProperties } from 'react';

type FlexType = CSSProperties['flex']; 

interface Props extends React.ComponentPropsWithoutRef<'div'> {
  xs_shrink?: number;
  xs_expand?: number;
  xs_width?: string; // auto | num% | numpx
  sm_shrink?: number;
  sm_expand?: number;
  sm_width?: string; // auto | num% | numpx
  md_shrink?: number;
  md_expand?: number;
  md_width?: string; // auto | num% | numpx
  lg_shrink?: number;
  lg_expand?: number;
  lg_width?: string; // auto | num% | numpx
  direction?: "row" | "column";
  log_it?: boolean;
}

export default function FlexBox(props: Props) {
  const { ref, widthCategory } = useGetWidthCategory();

  if (props.log_it) {
    debugger;
  }
  let use_style: CSSProperties = props.style ? { minHeight: 0, ...props.style } : { minHeight: 0 };
  let shrink = props.direction ? undefined : 1;
  let expand = props.direction ? undefined : 1;
  let width = props.direction ? undefined : "auto";
  if (props.direction) {
    use_style.display = "flex";
    use_style.flexDirection = props.direction;
  }
  switch (widthCategory) {
    case "lg": 
      if (props.lg_shrink !== undefined) {
        shrink = props.lg_shrink;
      } else if (props.md_shrink !== undefined) {
        shrink = props.md_shrink;
      } else if (props.sm_shrink !== undefined) {
        shrink = props.sm_shrink;
      } else if (props.xs_shrink !== undefined) {
        shrink = props.xs_shrink;
      }
      if (props.lg_expand !== undefined) {
        expand = props.lg_expand;
      } else if (props.md_expand !== undefined) {
        expand = props.md_expand;
      } else if (props.sm_expand !== undefined) {
        expand = props.sm_expand;
      } else if (props.xs_expand !== undefined) {
        expand = props.xs_expand;
      }
      if (props.lg_width !== undefined) {
        width = props.lg_width;
      } else if (props.md_width !== undefined) {
        width = props.md_width;
      } else if (props.sm_width !== undefined) {
        width = props.sm_width;
      } else if (props.xs_width !== undefined) {
        width = props.xs_width;
      }
    break;
    case "md": 
      if (props.md_shrink !== undefined) {
        shrink = props.md_shrink;
      } else if (props.sm_shrink !== undefined) {
        shrink = props.sm_shrink;
      } else if (props.xs_shrink !== undefined) {
        shrink = props.xs_shrink;
      }
      if (props.md_expand !== undefined) {
        expand = props.md_expand;
      } else if (props.sm_expand !== undefined) {
        expand = props.sm_expand;
      } else if (props.xs_expand !== undefined) {
        expand = props.xs_expand;
      }
      if (props.md_width !== undefined) {
        width = props.md_width;
      } else if (props.sm_width !== undefined) {
        width = props.sm_width;
      } else if (props.xs_width !== undefined) {
        width = props.xs_width;
      }
    break;
    case "sm": 
      if (props.sm_shrink !== undefined) {
        shrink = props.sm_shrink;
      } else if (props.xs_shrink !== undefined) {
        shrink = props.xs_shrink;
      }
      if (props.sm_expand !== undefined) {
        expand = props.sm_expand;
      } else if (props.xs_expand !== undefined) {
        expand = props.xs_expand;
      }
      if (props.sm_width !== undefined) {
        width = props.sm_width;
      } else if (props.xs_width !== undefined) {
        width = props.xs_width;
      }
    break;
    case "xs": 
      if (props.xs_shrink !== undefined) {
        shrink = props.xs_shrink;
      }
      if (props.xs_expand !== undefined) {
        expand = props.xs_expand;
      }
      if (props.xs_width !== undefined) {
        width = props.xs_width;
      }
    break;
  }
  if (shrink !== undefined || expand !== undefined || width !== undefined) {
    if (shrink === undefined) {
      shrink = 1;
    }
    if (expand === undefined) {
      expand = 1;
    }
    if (width === undefined) {
      width = "auto";
    }
    const flex_style: FlexType = `${expand} ${shrink} ${width}`;
    use_style.flex = flex_style;
  }
  const pass_along_props = {...props};
  delete pass_along_props.xs_expand;
  delete pass_along_props.xs_shrink;
  delete pass_along_props.xs_width;
  delete pass_along_props.sm_expand;
  delete pass_along_props.sm_shrink;
  delete pass_along_props.sm_width;
  delete pass_along_props.md_expand;
  delete pass_along_props.md_shrink;
  delete pass_along_props.md_width;
  delete pass_along_props.lg_expand;
  delete pass_along_props.lg_shrink;
  delete pass_along_props.lg_width;
  delete pass_along_props.log_it;
  delete pass_along_props.direction;
  delete pass_along_props.style;
  return (
    <div ref={ref} style={use_style} {...pass_along_props}>{ props.children }</div>
  );
}
